export default {
    ACCOUNT_RECEIVED: 'ACCOUNT_RECEIVED',
    ACCOUNT_SELECTED: 'ACCOUNT_SELECTED',
};
